import { Button, Modal, TextBlock } from '@skillarea/lib-frontend';
import { useTranslation } from 'react-i18next';

import styles from './MinimumAgeModal.module.scss';

type TMinimumAgeModalProps = {
  isOpen: boolean;
  minimumAge: number;
  onClose: () => void;
};

export function MinimumAgeModal({
  isOpen,
  minimumAge,
  onClose,
}: TMinimumAgeModalProps) {
  const { t } = useTranslation('modals');

  return (
    <Modal
      isOpen={isOpen}
      onBeforeClose={onClose}
      title={t('minimumAge.title')}
    >
      <div className={styles.content} data-testid="minimum-age-modal">
        <TextBlock
          color="contrast"
          data-testid="minimum-age-modal-message"
          weight="600"
        >
          {t('minimumAge.message', { age: minimumAge })}
        </TextBlock>

        <div className={styles.actions}>
          <Button
            color="accent"
            data-testid="minimum-age-modal-close"
            onClick={onClose}
            size="s"
            type="button"
            variant="outline"
          >
            {t('common.ok')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
